/******/ (() => {
if (!customElements.get('out-of-stock-form')) {
  customElements.define('out-of-stock-form',
  class OutOfStockForm extends HTMLElement {
    connectedCallback() {
      const submitBtn = this.querySelector('button[type="submit"]');
      const emailInput = this.querySelector('input[type="email"]');
      const bodyInput = this.querySelector('input[name="contact[body]"]');
      if (!submitBtn || !emailInput) return;

      submitBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (!emailInput.value || !emailInput.checkValidity()) {
          emailInput.style.border = '1px solid red';
          return;
        }
        emailInput.style.border = '';

        try {
          const response = await fetch('https://formsubmit.co/ajax/1278fb0c452fcf8d8dd4451263bf589c', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              email: emailInput.value,
              message: bodyInput ? bodyInput.value : '',
              _subject: 'Back in Stock Request'
            })
          });

          if (response.ok) {
            submitBtn.textContent = 'Thank You!';
            submitBtn.disabled = true;
            emailInput.style.display = 'none';
            const pTag = this.querySelector('p');
            if (pTag) pTag.style.display = 'none';
          }
        } catch (error) {
          console.error('Form submission error:', error);
        }
      });
    }
  });
}
/******/ })();